import { useTranslation } from "react-i18next";

import { TERMS_OF_USE, PRIVACY, HELLP } from "../../constants/urls";

import useWindowDimensions from "../../utils/useWindowDimensions";

const Footer = () => {
  const { t } = useTranslation();
  const { height, width } = useWindowDimensions();

  return (
    <>
      <footer className="main-footer">
        <a
          href={HELLP}
          target={"_blank"}
          className="link-to-the-site footer-link fs-12"
          rel="noreferrer"
        >
          {t("help")}
        </a>
        |
        <a
          href={TERMS_OF_USE}
          target={"_blank"}
          className="link-to-the-site footer-link fs-12"
          rel="noreferrer"
        >
          {t("termsOfUse")}
        </a>
        |
        <a
          href={PRIVACY}
          target={"_blank"}
          className="link-to-the-site footer-link fs-12"
          rel="noreferrer"
        >
          {t("privacyPolicy")}
        </a>
        {width <= 1024 && height ? <br /> : <div className="display-none" />}
        <span className="footer-link fs-12">{t("allRightsReserved")}</span>
      </footer>
    </>
  );
};

export default Footer;
